export const ENDPOINTS = {
  getUserData: "/cassowary/session/getuser",
};
